import React, { Component } from 'react';
import * as apis from '../../../common-utils/api_urls'
import * as translationUtils from '../../../common-utils/translation_utils'
import getOrderReport from '../../../services/getOrderReport';

/**
 * GenerateReport Class renders Generate Report sub-section
 */
class GenerateReport extends Component {



  /**
   * Handles URL change and passes order URL to MainWrapper Callback on Form Submit.
   */
  handleSubmit(e){
    window.loader(true);

    var generateReportDuration = window.jQuery('select[name=genrateReportSelect]').val();

    if(generateReportDuration!==''){
      getOrderReport(apis.getGenerateReportUrl(generateReportDuration), window.sessionStorage.getItem('token'));
    }else{
      window.loader(false);
      window.alert('Please Select Duration');
    }
  }



  render() {
    return (
      <div className="ph-nav-group">
        <div className="ph-nav-group__header">{translationUtils.getTranslation(1847,"Generate Report")}</div>
        <div className="ph-form">                
          <label className="ph-search__label" htmlFor="timeline">{translationUtils.getTranslation(1858,"Order Placed Within")}</label>
          <select id="timeline" name='genrateReportSelect'>
            <option value='' defaultValue>{translationUtils.getTranslation(133,"Select")}</option>
            <option value="30Days">{translationUtils.getTranslation(1860,"Last 30 Days")}</option>
            <option value="6Months">{translationUtils.getTranslation(1859,"Last 6 Months")}</option>
            <option value="CurrentYear">{translationUtils.getTranslation(1861,"Current Year")}</option>
            <option value="LastYear">{translationUtils.getTranslation(1862,"Last Year")}</option>
          </select>

        <button type="button" className="button  accent-button round-button small-button submit-button" onClick={this.handleSubmit}>{translationUtils.getTranslation(1848,"Export")}</button>
        </div>
      </div>
    );
  }
}

export default GenerateReport;
